import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import axios from 'axios'
import { API_URL } from '@/utils/constans'

export const usePrizeStore = defineStore('prize', () => {

    // ── Каталог призов (публичный, без авторизации) ──────────────────────────────
    const prizesList = ref([])
    const prizesLoaded = ref(false)

    const fetchPrizes = async (lang = 'ru') => {
        if (prizesLoaded.value) return
        try {
            const { data } = await axios.get(`${API_URL}/api/v1/prizes`, { params: { lang } })
            prizesList.value = data.items ?? []
            prizesLoaded.value = true
        } catch (err) {
            console.error('fetchPrizes:', err)
        }
    }

    // ── Пункты выдачи (публичный, без авторизации) ───────────────────────────────
    // Координаты: item.lat / item.lng → для ymaps3: [item.lng, item.lat]
    const pickupPoints = ref([])
    const selectedPickupId = ref(null)

    const fetchPickupPoints = async (lang = 'ru') => {
        try {
            const { data } = await axios.get(`${API_URL}/api/v1/pickup-points`, { params: { lang } })
            pickupPoints.value = (data.items ?? []).map(item => ({
                ...item,
                coords: [item.lng, item.lat],
            }))
        } catch (err) {
            console.error('fetchPickupPoints:', err)
        }
    }

    // ── Статус активации кода ────────────────────────────────────────────────────
    const codeVerified = ref(false)

    // ── Результат спина ──────────────────────────────────────────────────────────
    // Заполняется после вызова storeRequests.spin()
    // outcome: 'won' | 'empty' | 'no_attempts' | 'already_processed'
    const spinOutcome = ref(
        sessionStorage.getItem('pepsi_spin_outcome') || null
    )
    // prize_type: 'tshirt' | 'partner_code' | 'merch' | 'physical_weekly' | 'physical'
    // fulfillment_id — ID prize_fulfillment (для /customize), НЕ catalog id
    const wonPrize = ref(
        JSON.parse(sessionStorage.getItem('pepsi_won_prize') || 'null')
    )
    const partnerCode = ref(
        sessionStorage.getItem('pepsi_partner_code') || null
    )
    const emptyMessage = ref(null)
    const emptyCta = ref(null)
    const remainingAttempts = ref(0)

    // fulfillment_id из SpinResponse.prize.fulfillment_id — дублируется в localStorage
    const fulfillmentId = ref(
        Number(localStorage.getItem('pepsi_fulfillment_id')) || null
    )

    const setSpinResult = (data) => {
        spinOutcome.value = data.outcome
        wonPrize.value = data.prize ?? null
        partnerCode.value = data.partner_code ?? null
        emptyMessage.value = data.empty_message ?? null
        emptyCta.value = data.empty_cta_text ?? null
        remainingAttempts.value = data.new_attempts ?? 0
        sessionStorage.setItem('pepsi_spin_outcome', data.outcome)
        sessionStorage.setItem('pepsi_won_prize', JSON.stringify(data.prize ?? null))
        sessionStorage.setItem('pepsi_partner_code', data.partner_code ?? '')
        if (data.outcome === 'won' && data.prize?.fulfillment_id) {
            fulfillmentId.value = data.prize.fulfillment_id
            localStorage.setItem('pepsi_fulfillment_id', data.prize.fulfillment_id)
        }
    }

    // ── Computed ─────────────────────────────────────────────────────────────────
    const hasWon = computed(() => spinOutcome.value === 'won')
    const hasAttempts = computed(() => remainingAttempts.value > 0)

    const refreshSelectedPickup = () => {
        if (!selectedPickupId.value) return null
        return pickupPoints.value.find(p => p.id === selectedPickupId.value) ?? null
    }

    // ── Сброс ────────────────────────────────────────────────────────────────────
    const reset = () => {
        spinOutcome.value = null
        wonPrize.value = null
        partnerCode.value = null
        emptyMessage.value = null
        emptyCta.value = null
        selectedPickupId.value = null
        sessionStorage.removeItem('pepsi_spin_outcome')
        sessionStorage.removeItem('pepsi_won_prize')
        sessionStorage.removeItem('pepsi_partner_code')
    }

    return {
        prizesList, prizesLoaded, fetchPrizes,
        pickupPoints, selectedPickupId, fetchPickupPoints, refreshSelectedPickup,
        codeVerified,
        spinOutcome, wonPrize, partnerCode, emptyMessage, emptyCta,
        remainingAttempts, fulfillmentId, setSpinResult,
        hasWon, hasAttempts,
        reset,
    }
})
